module.exports = __webpack_public_path__ + "static/media/travelandhospitality_bg.c5b5475a.png";